export class PlanSupportCompanyInfo {
    constructor(
        public associatedCompanyId: string,
        public associatedCompanyName: string,
        public tradeStopDiv: string,
        public tradeStopName: string
    ) { }
};